// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__vz8vM","cell":"ColumnAccessor_cell__1SSB7","firstCellAccent":"ColumnAccessor_firstCellAccent__2GJya"};